export const BASIC_INNER_BLOCK = ["core/heading", "core/paragraph", "core/list", "core/buttons", "core/file"];

export const ICONS = [
    'fa-arrow-up-right-from-square',
    'fa-bars',
    'fa-bell',
    'fa-bicycle',
    'fa-briefcase',
    'fa-building-columns',
    'fa-calculator',
    'fa-calendar-check',
    'fa-calendar-days',
    'fa-calendar-week',
    'fa-calendar',
    'fa-car-side',
    'fa-car',
    'fa-chart-column',
    'fa-chart-line',
    'fa-check',
    'fa-circle-check',
    'fa-circle-exclamation',
    'fa-circle-info',
    'fa-circle-question',
    'fa-circle-question',
    'fa-circle-xmark',
    'fa-circle',
    'fa-clipboard',
    'fa-clock',
    'fa-clock',
    'fa-comment',
    'fa-credit-card',
    'fa-dog',
    'fa-download',
    'fa-droplet',
    'fa-dumpster',
    'fa-edit',
    'fa-ellipsis-vertical',
    'fa-envelope',
    'fa-euro-sign',
    'fa-exclamation',
    'fa-eye-slash',
    'fa-eye',
    'fa-face-frown',
    'fa-face-smile',
    'fa-file-lines',
    'fa-file-pdf',
    'fa-file-shield',
    'fa-filter',
    'fa-fire',
    'fa-folder-open',
    'fa-folder',
    'fa-hand-holding-heart',
    'fa-hand-point-up',
    'fa-handshake',
    'fa-horse',
    'fa-hourglass-half',
    'fa-house-medical',
    'fa-house',
    'fa-id-card',
    'fa-inbox',
    'fa-info',
    'fa-laptop',
    'fa-link',
    'fa-location-dot',
    'fa-lock-open',
    'fa-lock',
    'fa-map',
    'fa-minus',
    'fa-mobile-screen',
    'fa-money-bill-transfer',
    'fa-money-bill',
    'fa-mug-hot',
    'fa-newspaper',
    'fa-paper-plane',
    'fa-pen',
    'fa-percent',
    'fa-person-running',
    'fa-phone',
    'fa-plus',
    'fa-print',
    'fa-question',
    'fa-route',
    'fa-save',
    'fa-seedling',
    'fa-share',
    'fa-shield-alternate',
    'fa-shield-halved-right',
    'fa-shield-halved',
    'fa-shield',
    'fa-sim-card',
    'fa-sliders',
    'fa-soap',
    'fa-square-minus',
    'fa-square',
    'fa-star',
    'fa-thumbs-down',
    'fa-thumbs-up',
    'fa-trash-can',
    'fa-trash',
    'fa-tv',
    'fa-upload',
    'fa-user-group',
    'fa-user-shield',
    'fa-user-tie',
    'fa-user',
    'fa-users',
    'fa-wallet',
    'fa-xmark',
];
